import styled from "@emotion/styled";
import { rem } from "polished";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
`;

export const Dialog = styled.div`
  background: #ffffff;
  border-radius: ${rem(4)};
  box-shadow: 0 ${rem(4)} ${rem(20)} rgba(0, 0, 0, 0.25);
  width: ${rem(560)};
  max-width: calc(100vw - ${rem(32)});
  padding: ${rem(24)};
`;

export const Title = styled.h2`
  display: flex;
  align-items: center;
  gap: ${rem(10)};
  margin: 0 0 ${rem(8)} 0;
  font-size: ${rem(18)};
  font-weight: 600;
`;

export const Badge = styled.span`
  font-size: ${rem(12)};
  background: #0b69c7;
  color: #ffffff;
  border-radius: ${rem(10)};
  padding: ${rem(1)} ${rem(10)};
  font-weight: 600;
`;

export const Crumb = styled.div`
  background: #f3f5f7;
  border-radius: ${rem(3)};
  padding: ${rem(4)} ${rem(8)};
  font-family: Consolas, monospace;
  font-size: ${rem(12.5)};
`;

export const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${rem(8)};
  margin: ${rem(12)} 0;
`;

export const Stat = styled.div`
  border: 1px solid #d8dee4;
  border-radius: ${rem(4)};
  padding: ${rem(6)} ${rem(8)};
  text-align: center;

  b {
    display: block;
    font-size: ${rem(20)};
  }

  small {
    color: #6b7785;
  }
`;

export const Warning = styled.div`
  background: #fdecea;
  border-left: ${rem(4)} solid #b42318;
  padding: ${rem(8)} ${rem(12)};
  margin: ${rem(6)} 0;
  font-size: ${rem(14)};
`;

export const Message = styled.p`
  margin: ${rem(12)} 0;
  font-size: ${rem(14)};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${rem(8)};
  margin-top: ${rem(14)};
`;
